<!--eslint-disable-->
<template>
  <!-- IconBtn -->
  <transition name="">
    <div style="display: inline-block">
      <el-tooltip
        v-model="mouseSelect"
        :disabled="position !== 'tooltip'"
        :content="content"
        manual
        placement="top">
        <div
          :class="classs"
          :style="styles"
          class="newIconBtn"
          @click="clickBtn($event)"
          @mouseenter="mouseEnter"
          @mouseleave="mouseLeave">
          <svg-icon :icon-class="icon" />
          <div v-if="position === 'inside'" class="content-text">
            <span>{{ content }}</span>
          </div>
        </div>
      </el-tooltip>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '14'
    },
    color: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: ''
    },
    authCode: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'tooltip' // Optional  'tooltip'、'inside'
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mouseSelect: false
    }
  },
  computed: {
    classs() {
      return {
        'btn-is-focus': this.mouseSelect,
        'position-inside': this.position === 'inside'
      }
    },
    styles() {
      const style = {
        fontSize: this.size + 'px',
        color: this.color,
        background: this.bgColor
      }
      if (this.disable) {
        style.opacity = 0.5;
        style.cursor = 'not-allowed';
      }
      return style;
    }
  },
  methods: {
    clickBtn($event) {
      this.$emit('click', $event);
    },
    mouseEnter() {
      setTimeout(() => {
        this.mouseSelect = true;
      }, 100)
    },
    mouseLeave() {
      setTimeout(() => {
        this.mouseSelect = false;
      }, 100)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.btn-is-focus {
  // color: #409eff !important;
  // border: 1px solid #409eff !important;
}
.position-inside{
  padding: 5px 8px!important;
  .content-text{
    display: inline-block;
    margin-left: -3px;
  }
}
.newIconBtn {
  line-height: 1;
  background: #fcfcfc;
  margin-right: 5px;
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  // border: 1px solid #ccc;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 6px;
  font-size: 13px;
  // padding: 0 8px;
  border-radius: 2px;
  // border: 1px solid #e9e9e9 !important;
  -webkit-transition: color 0.2s linear, border 0.2s linear,
    background-color 0.2s linear, border 0.2s linear,
    -webkit-box-shadow 0.2s linear;
  transition: color 0.2s linear, border 0.2s linear,
    background-color 0.2s linear, border 0.2s linear, box-shadow 0.2s linear,
    -webkit-box-shadow 0.2s linear;
  color: #666666;
}
</style>
